const BONUS = {
    STATUSES: {
        CREATED: 1,
        ONGOING: 2,
        COMPLETED: 3,
        EXPIRED: 4,
        FORFEITURE: 5,
        LOST: 6,
        AUTOCOMPLETED: 7,
        ISSUED: 8
    },
    TYPES: {
        FREESPIN: 4,
        CASH: 5,
        JACKPOT_WIN: 13,
    }
};

let cachedInfoResponse = null;
let currentInfoPromise = null;

let currentAccountsPromise = null;
let cachedAccountsResponse = null;

let activePromotionsPromise = null;
let oldPromotionsPromise = null;

const getPlayerInfo = (useCache = false) => {
    if (useCache && cachedInfoResponse)
        return new Promise(resolve => { resolve(cachedInfoResponse); });

    if (currentInfoPromise)
        return currentInfoPromise;

    currentInfoPromise = new Promise((resolve, reject) => {
        fetch('/player/info')
            .then((response) => { return response.json(); })
            .then((response) => {
                if (response.success) {
                    cachedInfoResponse = response.data;
                    if (response.data?.affiliate_data?.btag) {
                        playerInfo.btag = response.data.affiliate_data.btag;
                    }
                    resolve(cachedInfoResponse);
                } else {
                    // API call failed
                    reject(response);
                }
                currentInfoPromise = null;
            });
    });

    return currentInfoPromise;
}

const getCSRFTokenValue = () => {
    const metaTags = document.getElementsByTagName('meta');
    for (const element of metaTags) {
        if (element?.name == 'csrf-token') {
            return element.content;
        }
    }
    return null;
}

const updatePlayerInfo = (newData, displayNotifications = true) => {
    let csrf = getCSRFTokenValue();
    let data = new FormData();
    for (let key in newData) {
        data.append(key, newData[key]);
    }

    return new Promise((resolve, reject) => {
        fetch('/player/update', {
            headers: {
                'X-CSRF-Token': csrf,
            },
            method: "POST",
            body: data,
        })
            .then((response) => { return response.json(); })
            .then((response) => {
                if (displayNotifications) {
                    if (!response.success) {
                        for (let error of response.errors ?? []) {
                            displayNotification(error.message);
                        }
                    } else {
                        for (let field in newData) {
                            switch (field) {
                                case 'street':
                                    playerInfo.address = newData[field]; break;
                                case 'birth_date':
                                case 'date_of_birth':
                                    playerInfo['birthDate'] = newData[field]; break;
                                case 'first_name':
                                    playerInfo.firstName = newData[field]; break;
                                case 'last_name':
                                    playerInfo.lastName = newData[field]; break;
                                case 'postal_code':
                                    playerInfo.postCode = newData[field]; break;
                                default:
                                    playerInfo[field] = newData[field];
                            }
                        }
                        setCioIdentity('playfina:' + playerInfo.apiId, playerInfo.email, null, newData); // registration timestamp will have already been sent, no need to resend it
                        displayNotification(translationsArray['infoSuccessfullyUpdated'] ?? '', NOTIFICATION_TYPE_SUCCESS);

                        const body = document.getElementsByTagName('body')[0];
                        const event = new Event('profileInfoUpdated');
                        body.dispatchEvent(event);
                    }
                }
                resolve(response);
            })
            .catch((response) => { reject(response); });
    });
}

const getPlayerAccounts = (useCache = false, refreshDisplays = false) => {
    if (useCache && cachedAccountsResponse) {
        if (refreshDisplays) $('body').trigger('mainCurrencyChangeComplete', [cachedAccountsResponse]);
        return new Promise(resolve => { resolve(cachedAccountsResponse); });
    }

    if (currentAccountsPromise)
        return currentAccountsPromise;

    currentAccountsPromise = new Promise((resolve, reject) => {
        fetch('/player/wallet')
            .then((response) => { return response.json(); })
            .then((response) => {
                let emptyAccounts = [], accountsWithMoney = [];
                for (let account of response) {
                    if (account.cents == 0) emptyAccounts.push(account);
                    else accountsWithMoney.push(account);
                }
                cachedAccountsResponse = [...accountsWithMoney, ...emptyAccounts];
                if (refreshDisplays) $('body').trigger('mainCurrencyChangeComplete', [cachedAccountsResponse]);
                resolve(cachedAccountsResponse);
                currentAccountsPromise = null;
            });
    });

    return currentAccountsPromise;
}

const changeMainCurrency = (currency, refreshDisplays = true, useCache = false) => {
    let saveCurrency = playerInfo.currency, saveSymbol = playerInfo.currencySymbol;
    let savePaymentCurrency = paymentInfo.currency, savePaymentSymbol = paymentInfo.symbol;

    const revertCurrency = () => {
        for(let i = 0; i < cachedAccountsResponse.length; i++) {
            if (cachedAccountsResponse[i].currency == saveCurrency) {
                cachedAccountsResponse[i].main = true;
            } else {
                cachedAccountsResponse[i].main = false;
            }
        }
        playerInfo.currency = saveCurrency;
        playerInfo.currencySymbol = saveSymbol;
        paymentInfo.currency = savePaymentCurrency;
        paymentInfo.currencySymbol = savePaymentSymbol;

        $('body').trigger('mainCurrencyChange', saveCurrency);
        $('body').trigger('mainCurrencyChangeComplete', [cachedAccountsResponse]);
    }

    playerInfo.currency = currency;
    paymentInfo.currency = currency;
    if (useCache && cachedAccountsResponse.length) {
        let mainAccount = cachedAccountsResponse.filter(current => current.currency == currency)[0] ?? {symbol: ''};
        playerInfo.currencySymbol = mainAccount.symbol;
        paymentInfo.currencySymbol = mainAccount.symbol;
    }
    if (refreshDisplays) {
        $('body').trigger('mainCurrencyChange', currency);
    }

    if (useCache && cachedAccountsResponse.length) {
        for (let i = 0; i < cachedAccountsResponse.length; i++) {
            if (cachedAccountsResponse[i].currency == currency) {
                cachedAccountsResponse[i].main = true;
            } else {
                cachedAccountsResponse[i].main = false;
            }
        }

        $.post('/player/change-account', {currency: currency})
            .done((data) => {
                if (data.success) return;

                revertCurrency();
                for (let error of data.errors) {
                    displayNotification(error.message);
                }
            })
            .fail(() => {
                revertCurrency();
                displayNotification(translationsArray.unknown_error);
            })

        $('body').trigger('mainCurrencyChangeComplete', [cachedAccountsResponse]);


        return new Promise(resolve => { resolve(cachedAccountsResponse); });
    }

    return new Promise((resolve, reject) => {
        $.post('/player/change-account', {currency: currency}).done(data => {
            if (!data) {
                playerInfo.currency = saveCurrency;
                reject(data);
                return;
            }
            playerInfo.currencySymbol = data.data.symbol;
            paymentInfo.currencySymbol = data.data.symbol;
            if (!refreshDisplays) {
                resolve(data);
                return;
            }

            getPlayerAccounts(false, true).then(() => { resolve(data); });
        }).fail(() => { revertCurrency(); });
    });
}

const updateCachedAccountAmount = (currency, amountCentsDelta) => {
    if (!cachedAccountsResponse.length) return;

    for (let i = 0; i < cachedAccountsResponse.length; i++) {
        if (cachedAccountsResponse[i].currency == currency) {
            cachedAccountsResponse[i].cents += amountCentsDelta;
            cachedAccountsResponse[i].withdraw_cents += amountCentsDelta;
            break;
        }
    }
}

const getActivePromotions = () => {
    if (!activePromotionsPromise) {
        activePromotionsPromise = new Promise((resolve, reject) => {
            fetch('/bonus/get-all?'  + new URLSearchParams({perPage: 100, page: 0}).toString())
                .then(response => response.json())
                .then(data => {
                    resolve(data);
                })
                .catch(reject)
                .finally(() => { activePromotionsPromise = null; });
        });
    }

    return activePromotionsPromise;
}

const getOldPromotions = () => {
    if (!oldPromotionsPromise) {
        oldPromotionsPromise = new Promise((resolve, reject) => {
            fetch('/bonus/get-old?'  + new URLSearchParams({perPage: 100, page: 0}).toString())
                .then(response => response.json())
                .then(data => {
                    resolve(data);
                })
                .catch(reject)
                .finally(() => { oldPromotionsPromise = null; });
        });
    }

    return oldPromotionsPromise;
}

const setErrorInput = (element, elementWrapper = null) => {
    element = element instanceof jQuery ? element : $(element);
    if (!elementWrapper) {
        const handleError = (e) => {
            const element = $(e.target);
            element.removeClass('error-input').off('input focusout', handleError);
        }

        element.addClass('error-input').on('input focusout', handleError);
    } else {
        elementWrapper = elementWrapper instanceof jQuery ? elementWrapper : $(elementWrapper);
        const handleError = (e) => {
            const element = $(e.target);
            elementWrapper.removeClass('error-input');
            element.off('input focusout', handleError);
        }

        elementWrapper.addClass('error-input');
        element.on('input focusout', handleError);
    }
}

const getMissingPlayerFieldsPayment = async (currency, methodId, action = PAYMENT_METHODS.ACTION.DEPOSIT) => {
    const fields = await getPaymentMethodFields(currency, methodId, action);
    if (!(fields.player ?? []).length) return [];

    return fields.player.filter(current => {
        let property = current.field;
        switch(property) {
            case 'mobile_phone':
                property = 'phone'; break;
            case 'last_name':
                property = 'lastName'; break;
            case 'first_name':
                property = 'firstName'; break;
            case 'postal_code':
                property = 'postCode'; break;
            case 'state':
                property = 'region_id'; break;
            case 'date_of_birth':
                property = 'birthDate'; break;
        }
        return !(playerInfo.hasOwnProperty(property) && playerInfo[property] && playerInfo[property] != '');
    });
}

const refreshUserVerification = (player) => {
    const userVerificationPhoneIcon = document.getElementsByClassName('playfina-user-verification-phone-icon');
    const userVerificationAccountIcon = document.getElementsByClassName('playfina-user-verification-account-icon');
    const userVerificationEmailIcon = document.getElementsByClassName('playfina-user-verification-email-icon');

    const cabinetVerifiedStatus = document.getElementsByClassName('playfinа-user-verified-display');
    const cabinetUnverifiedStatus = document.getElementsByClassName('playfinа-user-unverified-display');

    let verified = 0;
    if (player?.phone && player?.phone_verified) {
        for (element of userVerificationPhoneIcon) { element.classList.remove('unverified-icon'); }
        verified++;
    } else {
        for (element of userVerificationPhoneIcon) { element.classList.add('unverified-icon'); }
    }

    if (player.email_verification) {
        for (element of userVerificationEmailIcon) { element.classList.remove('unverified-icon'); }
        verified++;
    } else {
        for (element of userVerificationEmailIcon) { element.classList.add('unverified-icon'); }
    }

    if (player.account_verified) {
        for (element of userVerificationAccountIcon) { element.classList.remove('unverified-icon'); }
        verified++;
    } else {
        for (element of userVerificationAccountIcon) { element.classList.add('unverified-icon'); }
    }

    if (verified == 3) {
        for (element of cabinetVerifiedStatus) { element.classList.remove('d-none'); }
        for (element of cabinetUnverifiedStatus) { element.classList.add('d-none'); }
    } else {
        for (element of cabinetVerifiedStatus) { element.classList.add('d-none'); }
        for (element of cabinetUnverifiedStatus) { element.classList.remove('d-none'); }
    }
}

(() => {
    const shouldUrlRedirect = (urlArray) => {
        if (!urlArray.length) {
            return true;
        }

        // unrecognized modal param
        if (!['a', 'l', 'r', 'd'].includes(urlArray[0])) {
            return true;
        }

        // not possible to open anything or unrecognized param value
        const allowedAParamValues = [
            'dashboard', 'personal-cabinet', 'bonuses-available', 'bonuses-active', 'bonuses-history', 'bonuses-code', 'bonuses', 'notifications',
            'security', 'verification', 'my-profile', 'game-history', 'history-deposit', 'history-withdrawals', 'history-game-history', 'transaction-history',
            'login', 'register', 'l', 'r', 'deposit', 'right-menu'
        ];
        if (urlArray[0] == 'a'
            && (urlArray.length < 2 || !allowedAParamValues.includes(urlArray[1]))) {
            return true;
        }

        return false;
    }

    const handler = async (e) => {
        const localeLength = generalInfo.locale?.length || 2;
        let url = e.target.closest('a').getAttribute('href');

        // remove the locale if it's the same as the user's current one
        if (
            url.substr(0, localeLength + 1).toLowerCase() == generalInfo.locale + '/'
            || url.substr(0, localeLength + 2).toLowerCase() == '/' + generalInfo.locale + '/'
        ) {
            url = url.substr(localeLength + 1); // the following code will remove the leading slash if it's left by not trimming 4 characters
        }

        // trim url from closing and leading slashes
        while (url.charAt(0) == '/') url = url.substr(1);
        while (url.charAt(url.length - 1) == '/') url = url.substr(0, url.length - 1);

        const paramsArray = url.split('/');
        // Do the check if the url should redirect or not before we make the asynchronous call below
        // Otherwise if the player accounts haven't been cached the code execution in this function will stop to wait for the API request to be done
        // meanwhile the execution will continue for other handlers or more importantly the redirect from the link will be triggered
        // even if it wasn't supposed to be
        if (shouldUrlRedirect(paramsArray)) {
            return true;
        }
        e.preventDefault();

        const buildDepositParams = async (bonusCode, euroAmount) => {
            const userMainAccount = (await getPlayerAccounts(true)).find(account => account.main);
            if (!bonusCode) return {};

            const options = { startingBonusCode: bonusCode, preselectedBonusCodeSearch: bonusCode };
            if (!euroAmount) return options;

            let amount = convertCurrency(euroAmount, 'EUR', userMainAccount.currency);

            if (!userMainAccount.is_crypto) { // round up to the nearest 5
                amount = Math.ceil(amount);
                amount += amount % 5 ? (5 - (amount % 5)) : 0;
            } else if (!['BTC', 'BCH', 'LTC', 'ETH'].includes(userMainAccount.currency)) {
                amount = Math.round(amount);
            }

            options.preselectedAmount = amount;
            return options;
        }

        const paramGroups = [];
        let index = -1;
        for (const urlPart of paramsArray) {
            if (urlPart.length == 1) {
                index++;
                paramGroups[index] = [];
            }
            paramGroups[index].push(urlPart);
        }

        for (const urlArray of paramGroups) {
            switch(urlArray[0]) {
                case 'a':
                    const personalCabinetParams = [
                        'dashboard',
                        'personal-cabinet',
                        'bonuses-available',
                        'bonuses-active',
                        'bonuses-history',
                        'bonuses-code',
                        'bonuses',
                        'notifications',
                        'security',
                        'verification',
                        'my-profile',
                        'game-history',
                        'history-deposit',
                        'history-withdrawals',
                        'history-game-history',
                        'transaction-history',
                    ];

                    if (personalCabinetParams.includes(urlArray[1])) {
                        $('#personal-modal').trigger('showPersonalCabinetFromURL', [urlArray[1]]);
                    } else if (urlArray[1] == 'deposit' && playerInfo.email) { // if deposit modal and user logged-in
                        $('#make-deposit2').trigger('showDepositModal', [{}, false]); // no new options and don't reset current ones
                    } else if (urlArray[1] == 'login' || urlArray[1] == 'l' || urlArray[1] == 'deposit') { // if deposit and previous condition failed -> user not logged in show login modal
                        $('#modal-login').modal('show');
                    } else if (urlArray[1] == 'register' || urlArray[1] == 'r') {
                        $('#modal-signup').modal('show');
                    } else if (urlArray[1] == 'right-menu') {
                        $('.side-b').addClass('side-b-open');
                    }
                    break;

                case 'd':
                    if (!playerInfo.email) {
                        document.cookie =
                            'deposit-popup-options=' + urlArray[1] + (urlArray.length > 2 ? '/' + urlArray[2] : '') + ';'
                            + 'path=/';
                        $('#modal-signup').trigger('showModal');
                    } else {
                        $('#make-deposit2').trigger('showDepositModal', [ (await buildDepositParams(urlArray[1] ?? null, urlArray[2] ?? null)), true ]);
                    }
                    break;

                case 'l':
                case 'r':
                    if (!playerInfo.email) {
                        urlArray[0] == 'l' ? $('#modal-login').trigger('showModal', [urlArray[1] ?? false]) : $('#modal-register').trigger('showModal', [urlArray[1] ?? false]);
                    } else if (urlArray.length > 1 && urlArray[1] == 'd') { // handle /l/d/ and /r/d/ cases
                        $('#make-deposit2').trigger('showDepositModal', [ (await buildDepositParams(urlArray[2] ?? null, urlArray[3] ?? null)), true ]);
                    }
                    break;
            }
        }
    }
    document.querySelectorAll('a').forEach(element => {
        element.addEventListener('click', handler);
    });
})();

$(function() {
    const bodyElement = $('body');
    const nameDisplays = $('.playfina-user-name-display');
    const initialsDisplays = $('.playfina-user-initials-display');

    bodyElement.on('profileInfoUpdated', () => {
        if (playerInfo.firstName && playerInfo.lastName) {
            initialsDisplays.text(playerInfo.firstName.substr(0, 1).toUpperCase() + playerInfo.lastName.substr(0, 1).toUpperCase())
            nameDisplays.text(playerInfo.firstName + ' ' + playerInfo.lastName);
        } else if (playerInfo.firstName) {
            initialsDisplays.text(playerInfo.firstName.substr(0, 2))
            nameDisplays.text(playerInfo.firstName);
        } else if (playerInfo.lastName) {
            initialsDisplays.text(playerInfo.lastName.substr(0, 2))
            nameDisplays.text(playerInfo.lastName);
        } else {
            initialsDisplays.text(playerInfo.email.substr(0, 2))
            nameDisplays.text(playerInfo.email);
        }
    }).trigger('profileInfoUpdated');

    $('body').on('click', '.playfina__login-button', (e) => {
        if (!isLoginRegisterModalOpen()) {
            $('#modal-login').trigger('showModal');
        }

        e?.preventDefault(); // in case the clicked button is <a>
    });

    $('body').on('click', '.playfina__register-button', (e) => {
        if (!isLoginRegisterModalOpen()) {
            $('#modal-signup').trigger('showModal');
        }

        e?.preventDefault(); // in case the clicked button is <a>
    });

    $('.playfina__deposit-button').on('click', function (e) {
        e.preventDefault();

        const depositModal = $('#make-deposit2');
        const bonusCode = $(this).attr('data-bonus-code');
        const amount = $(this).attr('data-amount');
        const options = {};
        if (amount && !isNaN(amount)) {
            paymentInfo.amount = Number(amount);
            options.preselectedAmount = Number(amount);
        } else {
            paymentInfo.amount = null;
        }

        options.forceHideWelcomePackage = false; // activated only from the url
        if (bonusCode) {
            options.startingBonusCode = bonusCode;
            if ($(this).attr('data-bonus-code-filter') == 'true') options.preselectedBonusCodeSearch = bonusCode;
        }
        if ($(this).attr('data-bonus-code-searches') == 'true') {
            options.bonusCodeSearches = true;
        }
        if ($(this).attr('data-payment-method')) {
            options.preselectedPaymentMethod = $(this).attr('data-payment-method');
        }
        const resetOptions = $(this).attr('data-reset-options') != 'false';
        depositModal.trigger('showDepositModal', [options, resetOptions]);
    });

    bodyElement.on('mainCurrencyChangeComplete', function(event, accounts) {
        Object.assign(playerAccounts, accounts);
        for (let account of accounts) {
            if (account.currency == paymentInfo.currency) {
                let symbol = account.symbol ?? account.currency;
                $(".user-top-menu__currency").text(symbol + (account.cents/account.subunits_to_units));
            }
        }
    });

    bodyElement.on('playerWishpointsUpdate', () => {
        let points = playerInfo.points;

        let i = 1;
        while (i < levels.length && levels[i].required_points <= points) i++;
        if (i > 0) i--;
        playerInfo.level = levels[i].level;
        playerInfo.points = points;
        let nextLevelPoints = levels[i + 1]?.required_points ? Number(levels[i + 1].required_points) : Number(levels[i].required_points);
        let nextLevelPointsDiff = levels[i + 1]?.required_points ? Number(levels[i + 1].required_points) - levels[i].required_points : Number(levels[i].required_points) - Number(levels[i - 1]?.required_points ?? 0);
        playerInfo.levelPercent = Math.min(100 * ((points - levels[i].required_points) / (nextLevelPointsDiff)), 100);
        if (playerInfo.levelPercent == Infinity || playerInfo.levelPercent < 0 || playerInfo.levelPercent > 100) playerInfo.levelPercent = 100;
        playerInfo.levelImageUrl = levels[i].imageUrl;
        playerInfo.nextLevelPoints = nextLevelPoints;
        playerInfo.levelName = levels[i].display_name;
        playerInfo.currentLevelPoints = Number(levels[i].required_points);

        if(playerInfo.nextLevelPoints - playerInfo.points) {
            $('.playfina-player-level-number').html(Number(playerInfo.level) + 1);
        } else {
            $('.playfina-player-level-number').html(playerInfo.level);
        }
        //$('.playfina-player-level-number').html(playerInfo.level);
        $.each($('.playfina_level_boxes'), function (i, element) {
            let boxLevel = $(element).data('level');
            let backgroundImage = $(element).data('background');
            let activeHtml = "<span class='vip-numbers playfina_vip_numbers_active' style='background: url(" + backgroundImage + ") center center no-repeat; background-size: cover;'> " + boxLevel + " </span></span>";
            if (boxLevel <= playerInfo.level) {
                $(element).find('div.vip-status-c').removeClass('vip-gray');
                $(element).find('div.playfina_level_box_inactive').html(activeHtml);
            }
        })

        if (playerInfo.level == levels.length - 1) {
            $('.playfina-player-level-progress-bar').css('width', '100%');
            $('.user_level_progress').html(max_level_reached_label);
        } else {
            $('.playfina-player-level-progress-bar').css('width', playerInfo.levelPercent + '%');
            $('.playfina-player-next-level-number').html(Number(playerInfo.level) + 1);
            //$('.playfina-next-level-points-left').html(Math.max(0, playerInfo.nextLevelPoints - playerInfo.points));
            $('.playfina-prev-level-points').html(playerInfo.currentLevelPoints);
        }

        // VIP
        let desktopLevelImage = $('img.current_desktop_image_level');
        let mobileLevelImage = $('img.current_mobile_image_level');
        let desktopImage = $('img.playfina-levels-component__desktop-image[data-index="' + (Number(playerInfo.level) - 1) + '"]');
        let mobileImage = $('img.playfina-levels-component__mobile-image[data-index="' + (Number(playerInfo.level) - 1) + '"]');

        if (desktopImage.length && desktopLevelImage.length) {
            desktopLevelImage.attr('src', desktopImage.attr('src'));
        }

        if (mobileImage.length && mobileLevelImage.length) {
            mobileLevelImage.attr('src', mobileImage.attr('src'));
        }

        $('.reach-points__value').each(function (i, value) {
            let level = $(value).data('level');
            let points = $(value).data('points');
            if (level == (Number(playerInfo.level) + 1)) {
                $(value).html(points - playerInfo.points);
            } else {
                $(value).html(points);
            }
        });

        bodyElement.trigger('playerLevelCalculatedTrigger');
    });

    // Show the mobile footer menu and banner only after the event handler for clicking on the <a> tags has been attached
    const menu = $('#playfina-bottom-menu');
    const banner = $('#playfina-bottom-banner');

    if (menu.length) menu.removeClass('d-none');
    if (banner.length) banner.removeClass('d-none');
});

var handleFormErrors = (data) => {
    const errors = data.errors ? data.errors : null;
    if (errors) {
        for (let errorObj in errors) {
            // errorObj = {code:..., message:"...", ?field:"..."}
            let field = errors[errorObj].field ? errors[errorObj].field : null;
            if (field) {
                const object = $('.bottom-new-popup .div.position.relative input[name="' + field + '"]');
                if (object.length) {
                    setErrorInput(object);
                } else {
                    displayNotification(errors[errorObj].message);
                }
            } else {
                displayNotification(errors[errorObj].message);
            }
        }
    } else {
        // shouldn't happen
        displayNotification(translationsArray['general_error']);
    }
}